import React, { useEffect, useState } from 'react'

import styles from './Loading.css'
// @ts-ignore
import RawFormattedMessage from './RawFormattedMessage'

const assetPrefix = process.env.ASSET_PREFIX || ''

const error = (
  <section className={styles.root}>
    <header>
      <img
        src={`${assetPrefix}/static/info.svg`}
        className={styles.reloadIcon}
      />
      <h1>Couldn't load the page</h1>
    </header>
    <p>
      This is probably due to a technical problem. Your information is not lost.
    </p>
    <button
      className={styles.reload}
      type='submit'
      onClick={() => window.location.reload()}
    >
      <RawFormattedMessage id='Reload' />
    </button>
  </section>
)

const loading = (
  <section id='loading' className={styles.root}>
    <div className={styles.spinner}>
      <div className={styles.spinnerElement} />
      <div className={styles.spinnerElement} />
      <div className={styles.spinnerElement} />
      <div className={styles.spinnerElement} />
    </div>
  </section>
)

export default function Loading (_: { retry?: boolean }) {
  const [showTimeoutScreen, setShowTimeoutScreen] = useState(false)
  useEffect(() => {
    const timer = window.setTimeout(() => {
      setShowTimeoutScreen(true)
    }, 1000)
    return () => window.clearTimeout(timer)
  }, [])

  if (showTimeoutScreen) {
    return error
  }

  return loading
}
